import {SET_CREATING_NEW_PACK} from 'constants/action-types.js';
import {SET_PACK_WINDOW_POSITION} from 'constants/action-types.js';
import {SET_DRAGGING_PACK_WINDOW} from 'constants/action-types.js';
import {SET_PACK_TO_EDIT} from 'constants/action-types.js';
import {SET_PACK_SELECTED} from 'constants/action-types.js';

let initialState = {
    windowPosition: {x: 500, y: 200},
    packSelected: undefined
};
    
const packsReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_PACK_SELECTED:
        return {
            ... state,
            packSelected: action.payload
        };
    case SET_CREATING_NEW_PACK:
        return {
            ... state,
            creatingNewPack: action.payload
        };
    case SET_PACK_WINDOW_POSITION:
        return {
            ... state,
            windowPosition: action.payload
        };
    case SET_DRAGGING_PACK_WINDOW:
        return {
            ... state,
            draggingWindow: action.payload // contains the offset of the drag
        };
    case SET_PACK_TO_EDIT:
        return {
            ... state,
            packToEdit: action.payload // contains the offset of the drag
        };
    default:
        return state;
    }
};

export default packsReducer;
